function userLdapForm()
{
    const form = document.querySelector('.ldap-form');
    const formType = form.name;
    if (form) {
        const isRoleChange = document.querySelector('.is-role-change');
        const categorySelect = document.querySelector('.ldap-category-select');
        const formType = categorySelect.value;

        isRoleChange.value = false;
        categorySelect.value = assignValue(form);

        categorySelect.addEventListener('change', (event) => {
            isRoleChange.value = true;
            if (categorySelect.value !== formType) {
                form.submit();
            }
        });
    }
}
function assignValue(form)
{
    if (form.classList.contains('concipient-form')) {
        return 'ROLE_CONCIPIENT';
    }
    if (form.classList.contains('candidate-form')) {
        return 'ROLE_CANDIDATE';
    }
    if (form.classList.contains('legal-officer-form')) {
        return 'ROLE_LEGAL_OFFICER';
    }
    if (form.classList.contains('employee-form')) {
        return 'ROLE_EMPLOYEE';
    }
    if (form.classList.contains('executor-form')) {
        return 'ROLE_EXECUTOR';
    }
}
